import { createSlice } from '@reduxjs/toolkit'

/**
 * Drafts Slice
 * Manages submission draft state including file upload tracking
 */
const draftsSlice = createSlice({
  name: 'drafts',
  initialState: {
    uploadsInProgress: {}, // { 'draft-123': ['pdf', 'xml', 'invoice'] }
  },
  reducers: {
    startFileUpload: (state, action) => {
      const { draftId, fileType } = action.payload
      if (!state.uploadsInProgress[draftId]) {
        state.uploadsInProgress[draftId] = []
      }

      if (!state.uploadsInProgress[draftId].includes(fileType)) {
        state.uploadsInProgress[draftId].push(fileType)
      }
    },
    endFileUpload: (state, action) => {
      const { draftId, fileType } = action.payload
      const uploads = state.uploadsInProgress[draftId] || []
      const filtered = uploads.filter(type => type !== fileType)

      if (filtered.length === 0) {
        delete state.uploadsInProgress[draftId]
      } else {
        state.uploadsInProgress[draftId] = filtered
      }
    },
  },
})

export const { endFileUpload, startFileUpload } = draftsSlice.actions
export default draftsSlice.reducer
